import { getAggregatedTitleImage } from '../common';
import { Layout } from '../layout/types';
import { Recording } from '../recordings/types/recording';
import { Title } from '../titles/types/title';

export function createCwAsEditorialItems(
  cwData: Title[] | undefined,
  pattern?: Layout.Pattern,
  recordings?: Recording[],
): Layout.SectionItem[] {
  if (!cwData) {
    return [];
  }

  return cwData.map((item) => {
    const { masterId, slug, bookmark } = item;
    const relatedRecordings =
      bookmark && recordings ? getRelatedRecordings(recordings, bookmark.platformTitleId) : undefined;

    return {
      type: 'title',
      id: masterId,
      slug: slug,
      name: getCwTitle(item),
      image: getAggregatedTitleImage(item.series?.masterId ?? masterId, pattern === 'wide' ? 'wide' : 'poster'), // Needed this workaround as images path contains non Title related ID
      icon: '',
      pageStyle: Layout.PageViewStyleType.SWIMLANE,
      params: null,
      title: { ...item, recordings: relatedRecordings } as unknown as Title,
    };
  });
}

function getCwTitle(item: Title) {
  const { titleName, type } = item;
  if (item.episode && type === 'episode') {
    return item.episode.titleName;
  }

  return titleName;
}

function getRelatedRecordings(recordings: Recording[], platformTitleId: string): Recording[] {
  return recordings.filter((rec) => {
    if (rec.type === 'series') {
      return rec.episodes.some((ep) => ep.programId === platformTitleId);
    }

    return rec.programId === platformTitleId;
  });
}
